import { render, staticRenderFns } from "./alte.vue?vue&type=template&id=5740c225&scoped=true&"
import script from "./alte.vue?vue&type=script&lang=js&"
export * from "./alte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5740c225",
  null
  
)

export default component.exports